<cap-header [appLogo]="logoPath" [welcomePage]="'/home/dashboard'" alt="Logo" appTitleKey="layouts.page.title">
  @if (isMizenEnabled()) {
    <li>
      <cap-mizen-inbox></cap-mizen-inbox>
    </li>
  }
  <li>
    <cap-user-picker>
      @if (passwortAendernParam || emailAendern) {
        @if (passwortAendernParam) {
          <div>
            <button (click)="openPasswortAendern()" class="dropdown-item">
              {{ "layouts.passwortAendern" | translate }}
            </button>
          </div>
        }
        @if (emailAendern) {
          <div>
            <button (click)="openAccountManagement()" class="dropdown-item">
              {{ "layouts.emailAendern" | translate }}
            </button>
          </div>
        }
        <div class="dropdown-divider"></div>
      }
    </cap-user-picker>
  </li>
</cap-header>

<div class="bsg-content-wrapper">
  <nav [attr.aria-label]="'layouts.page.titleNavigation' | translate" id="navigation">
    <cap-environment-marker></cap-environment-marker>
    <cap-bsg-nav-menu>
      @for (item of root?.activatedChildren; track item) {
        <cap-bsg-nav-item
          [deactivated]="item.deactivated"
          [href]="item.content.href"
          [icon]="item.content.icon"
          [labelKey]="item.content.text"
          [target]="item.content.target"
          [tooltipKey]="item.content.text"
          [url]="item.content.link">
          @for (item2 of item?.activatedChildren; track item2) {
            <cap-bsg-nav-item
              [deactivated]="item2.deactivated"
              [href]="item2.content.href"
              [icon]="item2.content.icon"
              [labelKey]="item2.content.text"
              [target]="item2.content.target"
              [tooltipKey]="item2.content.text"
              [url]="item2.content.link">
              @for (item3 of item2?.activatedChildren; track item3) {
                <cap-bsg-nav-item
                  [deactivated]="item3.deactivated"
                  [href]="item3.content.href"
                  [icon]="item3.content.icon"
                  [labelKey]="item3.content.text"
                  [target]="item3.content.target"
                  [tooltipKey]="item3.content.text"
                  [url]="item3.content.link">
                </cap-bsg-nav-item>
              }
            </cap-bsg-nav-item>
          }
        </cap-bsg-nav-item>
      }
    </cap-bsg-nav-menu>
  </nav>

  <main id="content" role="main">
    <cap-alert-list id="alert-wrapper"></cap-alert-list>

    <router-outlet></router-outlet>
  </main>
</div>
